import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './event-form.style';

export type EventRowProps = {
  icon?: React.FC;
  // takes the icon's place when the marker is data-driven rather than a static glyph
  // (the calendar row's colour dot); falls back to `icon` when absent
  startSlot?: React.ReactNode;
  label?: string;
  // the value column hugs its content instead of stretching (toggles, chips)
  autoWidthField?: boolean;
  // the icon tracks the value's first line instead of its middle — for values that wrap
  alignTop?: boolean;
  isLoading?: boolean;
  skeletonWidth?: string;
  children: React.ReactNode;
};

export const EventRow: React.FC<EventRowProps> = ({
  icon,
  startSlot,
  label,
  autoWidthField,
  alignTop,
  isLoading,
  skeletonWidth = '100%',
  children,
}) => (
  <Styled.Item $autoWidthField={autoWidthField} $alignTop={alignTop}>
    <Styled.Label $alignTop={alignTop}>
      {startSlot ??
        (!!icon && (
          <Styled.Icon>
            <Icon icon={icon} size={16} />
          </Styled.Icon>
        ))}
      {!!label && <Styled.LabelText>{label}</Styled.LabelText>}
    </Styled.Label>
    {isLoading ? (
      <Styled.FieldSkeleton>
        <Skeleton animation="wave" width={skeletonWidth} height="1.6rem" />
      </Styled.FieldSkeleton>
    ) : (
      <Styled.Value $alignTop={alignTop}>{children}</Styled.Value>
    )}
  </Styled.Item>
);
